export default __webpack_public_path__ + "static/media/logo-text.6c498cb7.png";